// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"80202150","133":"dbe72e7f","191":"79a588e3","276":"545a4cb6","319":"9818832a","347":"f1c781d9","381":"6e92a762","455":"65da83c8","499":"1457681d","625":"fbc24b27","724":"9a46e7a1","738":"32a136da","761":"0b3d9dc6","955":"f85c87d9","964":"ce857bf9","977":"9eb781aa"}[chunkId] + ".chunk.js";
};